import Startups from './container';

export default Startups;
